import { IGrantAmendmentServices } from './grantAmendment.types'
import { IGrantAmendment, IGrantAmendmentData } from '@/entities'
import { http } from '@/shared/https'
import { Utilities as utils } from '@/shared/utilities'
import { AppTransformers as transform } from '@/shared/transform'

export class GrantAmendmentService implements IGrantAmendmentServices {

    createGrantAmendment(grantAmendment: any): any {
        return http.post(`api/GrantAmendment`, grantAmendment).then((resp: any) => {
            return resp.data;
        })
    }

    /** method to get the grantAmendment*/
    getGrantAmendment(id: number): any {
        return http.get(`api/GrantAmendment/${id}/Details`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        });
    }

    /** method to get the getGrantAmendmentDetails*/
    getGrantAmendmentDetails(id: number): any {
        return http.get(`api/GrantAmendment/Details/${id}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        });
    }

    /** method to list Amendments */
    listGrantAmendments(id: number): any {
        return http.get(`api/GrantAmendment/Grant/${id}/List`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            });
    }

    listAmendmentTypes(id: number): any {
        return http.get(`api/GrantAmendment/${id}/Types`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            });
    }

    /** method to update the grant amendment */
    updateAmendment(id: number, grantAmendment: any): any {
        return http.put(`api/GrantAmendment/${id}`, grantAmendment).then((resp: any) => {
            return resp.data
        });
    }

    /** method to update the grant amendment */
    StartAmendmentDetail(id: number): any {
        return http.put(`api/GrantAmendment/Detail/${id}/Start`, {})
            .then((resp: any) => {
                return resp.data
            });
    }

    /** method to update the grant amendment */
    UpdateAmendmentDetail(id: number, grantAmendmentDetail: any): any {
        return http.put(`api/GrantAmendment/Detail/${id}`, grantAmendmentDetail).then((resp: any) => {
            return resp.data
        });
    }

    /** method to update the grant amendment Detail*/
    UpdateAmendmentDetailData(id: number, grantAmendmentDetail: any, amendmentType: string): any {
        return http.put(`api/GrantAmendment/Detail/${id}/${amendmentType}`, grantAmendmentDetail).then((resp: any) => {
            return resp.data
        });
    }

    /** method to update the grant amendment */
    UpdateAmendmentData(id: number, data: any): any {
        return http.put(`api/GrantAmendment/${id}/Data`, data).then((resp: any) => {
            return resp.data
        });
    }

    /** transform ES model data to Schema form compatable foramt */
    transformDBEntity(data: any, indicators: any) {

        // #. transform the monitoring plan
        let monitoringPlan: any = transform.transformPMPDbEntity(data.monitoringPlan, indicators)

        data.monitoringPlan = {};
        data.monitoringPlan.indicators = monitoringPlan.mapping;
        data.monitoringPlan.data = monitoringPlan.data;

        return data;
    }

    exportToExcel(id: any, filename: string, context?: string) {
        http.getFile(`api/GrantAmendment/Budget/${id}/Export/${context}`, 'application/vnd.ms-excel')
            .then((resp: any) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', `${filename || 'Budget'}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
    }
}